import { useState } from "react";
import { useNavigate } from "@tanstack/react-router";

import { Button } from "@monorepo-apps/ui/src/components/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@monorepo-apps/ui/src/components/dialog";

import { useUpsertProduct } from "@/application/use-cases/products/use-products.queries";
import {
  ProductFormBody,
  type ProductFormValues,
} from "@/presentation/components/products/product-form-body";

interface CreateProductDialogProps {
  open: boolean;
  onClose: () => void;
}

export function CreateProductDialog({ open, onClose }: CreateProductDialogProps) {
  const [values, setValues] = useState<ProductFormValues | null>(null);
  const upsert = useUpsertProduct();
  const navigate = useNavigate();

  const handleSave = () => {
    if (!values || !values.slug || !values.name) return;
    upsert.mutate(values, {
      onSuccess: (row) => {
        onClose();
        void navigate({ to: "/products/$slug", params: { slug: row.slug } });
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="!max-w-2xl">
        <DialogHeader>
          <DialogTitle>New product</DialogTitle>
        </DialogHeader>
        <ProductFormBody initial={null} onChange={setValues} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={upsert.isPending || !values?.slug || !values?.name}
          >
            {upsert.isPending ? "Creating…" : "Create"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
